// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5f1a4df8","513":"ebc0ec40","703":"cb24c72b"}[chunkId] + ".chunk.js";
};